import React from 'react';

import {TabbedForm} from 'components/@common/widgets/tabbed-form';
import {Changelog} from 'components/@common/widgets/tabbed-form/common-tabs/changelog';
import {IChangelogEntity} from 'components/@common/widgets/tabbed-form/common-tabs/changelog/changelog.types';
import {
    ERIFormTabs,
    ERIFormTabTitles,
} from 'components/ais/reclaiming-information-card/reclaiming-information-card.constants';
import {ReclaimingMainInfo} from 'components/ais/reclaiming-information-card/tabs/reclaiming-main-info/reclaiming-main-info';
import {ETablePageQueryParams} from 'pages/table-page/query-params-aware-table/constants/table-query-params.constants';
import {useQueryParams} from 'shared/utils/query-params';
import {useGetReclaimingInformationQuery} from 'store/api/reclaiming-information/reclaiming-information.api';

export interface IReclaimingInformationCardProps {
    id: string;
}

export const ReclaimingInformationCard = ({id}: IReclaimingInformationCardProps) => {
    const {removeQueryParams} = useQueryParams();

    const {
        data: reclaimingInfo,
        isLoading,
    } = useGetReclaimingInformationQuery({id}, {skip: !id});

    const changelogData: IChangelogEntity[] | undefined = reclaimingInfo?.audits?.map(a => ({
        id: a.id,
        stage: a.stage,
        statusCode: a.statusCode,
        statusText: a.statusText,
        createdDate: a.createdDate,
        updatedDate: a.lastModifiedDate,
    }));

    const handleClose = () => removeQueryParams([ETablePageQueryParams.entity]);

    return (
        <TabbedForm
            title={reclaimingInfo ? `Карточка требования №${reclaimingInfo?.mainDocNumber}` : ' '}
            defaultTabKey={ERIFormTabs.main}
            isLoading={isLoading}
            modalWrapped
            emptyProps={{
                isEmpty: !reclaimingInfo,
                description: 'Информация о требовании не найдена',
            }}
            onClose={handleClose}
            tabs={reclaimingInfo && (
                [
                    {
                        key: ERIFormTabs.main,
                        title: ERIFormTabTitles.main,
                        content: (
                            <ReclaimingMainInfo
                                id={id}
                                initialLoadedData={reclaimingInfo}
                                onClose={handleClose}
                            />
                        ),
                    },
                    {
                        key: ERIFormTabs.changes,
                        title: ERIFormTabTitles.changes,
                        content: changelogData && (
                            <Changelog
                                changelogData={changelogData}
                            />
                        ),
                    },
                ]
            )}
        />
    );
};
